import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { PharmacyOrderPreferredTimeOfDayType, PharmacyOrderStatus } from "@/Common/Models/UI/Enums";
import { PharmacyOrderPrescriptionType } from "../Common/PharmacyOrderPrescriptionType";

import CircleFill from "@/DesignSystem/Atoms/Icons/Types/Circle/circle-fill.svg";
import Circle from "@/DesignSystem/Atoms/Icons/Types/Circle/circle-regular.svg";
import CircleHalf from "@/DesignSystem/Atoms/Icons/Types/CircleHalf/circle-half-regular.svg";
import Moon from "@/DesignSystem/Atoms/Icons/Types/Moon/moon-fill.svg";
import Sun from "@/DesignSystem/Atoms/Icons/Types/Sun/sun-fill.svg";
import SunHorizon from "@/DesignSystem/Atoms/Icons/Types/SunHorizon/sun-horizon-fill.svg";

class PharmacyOrderHelper {
    public static getPreferredTimeOfDay(preferredTimeOfDay: PharmacyOrderPreferredTimeOfDayType): { iconType: JSX.Element, label: string } {
        const label = EnumHelper.getVocab(PharmacyOrderPreferredTimeOfDayType, "Enums_PharmacyOrderPreferredTimeOfDay_", preferredTimeOfDay);

        switch (preferredTimeOfDay) {
            case PharmacyOrderPreferredTimeOfDayType.Morning:
                return { iconType: <SunHorizon />, label };
            case PharmacyOrderPreferredTimeOfDayType.Afternoon:
                return { iconType: <Sun />, label };
            case PharmacyOrderPreferredTimeOfDayType.Evening:
                return { iconType: <Moon />, label };
            default:
                return { iconType: null, label: null };
        }
    }

    public static getPrescriptionType(prescriptionType: PharmacyOrderPrescriptionType): { iconType: JSX.Element, label: string } {
        const label = EnumHelper.getVocab(PharmacyOrderPrescriptionType, "Enums_PharmacyOrderPrescriptionType_", prescriptionType);

        switch (prescriptionType) {
            case PharmacyOrderPrescriptionType.Full:
                return { iconType: <CircleFill />, label };
            case PharmacyOrderPrescriptionType.Partial:
                return { iconType: <CircleHalf />, label };
            case PharmacyOrderPrescriptionType.Empty:
                return { iconType: <Circle />, label };
            default:
                return { iconType: null, label: null };
        }
    }

    public static hasSendNotification(orderStatus: PharmacyOrderStatus): boolean {
        if (orderStatus === PharmacyOrderStatus.ToPrepare) {
            return true;
        }

        return false;
    }
}

export { PharmacyOrderHelper };
